'use client';

import { useRouter } from 'next/navigation';
import { getNextApiUrl } from '@/utils/next-api';

export const useHandleSignEContract = () => {
  const { replace } = useRouter();

  const handleSignEContract = () => {
    replace(
      getNextApiUrl('auth/complete-register?redirectUrl=/profile/contracts')
    );
  };

  return {
    handleSignEContract,
  };
};
